import { Link as MuiLink } from "@mui/material";
import { T } from "components/util/t";
import { Link } from "react-router-dom";
import { recursiveSnakeToCamel } from "utils/utils";

export const PaymentLink = ({ payment: p }) => {
    const payment = recursiveSnakeToCamel(p);
    const props = payment.directCharge ?
        {
            component: "a",
            href: `https://dashboard.stripe.com/payments/${payment.intentId}`,
            target: "_blank",
            children: <T>View transaction in Stripe</T>
        } : {
            component: Link,
            to: `/director/payments/${payment.id}`,
            children: payment.intentId
        };

    return (
        <li>
            <MuiLink variant="label" underline="always" {...props} />
        </li>
    );
};
